import AccountingEntry from "./accounting-entries";

interface AccountingEntriesGroup {
  id?: number;
  companyId?: number;
  storeSaleId?: number;
  storeExpenseId?: number;
  externalRelatedId?: string;
  extenalRelatedType?: string;
  status?: string;
  date?: string;
  obs?: string;
  items?: AccountingEntry[];
}

export const newAccountingEntryGroup = (): AccountingEntry => {
  return {};
};

export default AccountingEntriesGroup;
